<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="不良品项编号">
					<c-input name="defects_code"></c-input>
				</m-search-item>
				<m-search-item label="不良品项名称">
					<c-input name="defects_name"></c-input>
				</m-search-item>
			</m-search>

			<m-operate :batch="batchData.length" @batchCancel="batchCancel">
				<c-button color="main" v-if="auth('b_defects_edit')" v-lock="lock('b_defects_edit')" prepend-icon="tf-add" @click="editDicDefects()">创建不良品项</c-button>
				<c-button v-if="auth('b_defects_edit')" v-lock="lock('b_defects_edit')" prepend-icon="tf-import" @click="excelImport()">导入</c-button>
				
				<template #batch>
					<c-button v-if="auth('b_defects_edit')" v-lock="lock('b_defects_edit')" prepend-icon="tf-trash" color="red" :hollow="true" @click="batchRemoveDicDefects">删除</c-button>
				</template>
				
				<template #right>
					<c-button v-if="auth('b_defects_log')" v-lock="lock('b_defects_log')" prepend-icon="tf-import-record" @click="loadImportLogDetail()">导入记录</c-button>
					<c-button v-if="auth('b_defects_log')" v-lock="lock('b_defects_log')" prepend-icon="tf-operate-record" @click="loadWorkLogDetail()">操作记录</c-button>
				</template>
			</m-operate>

			<c-table ref="list" height="grow">
				<c-table-column
					type="selector"
					width="32"
					@handle="batchSelect"
				></c-table-column>

				<c-table-column
					label="不良品项编号"
					name="defects_code"
					width="150"
				>
				</c-table-column>
				
				<c-table-column
					label="不良品项名称"
					name="defects_name"
					width="300"
				>
				</c-table-column>

				<c-table-column
					label="创建人"
					name="create_user_realname"
					width="110"
				>
				</c-table-column>

				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="110"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_defects_edit')" v-lock="lock('b_defects_edit')" icon="tf-edit" @click="editDicDefects(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_defects_edit')" v-lock="lock('b_defects_edit')" icon="tf-trash" color="red" @click="removeDicDefects(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	import {batchData, batchMethods} from '@/components/public/batch.js'

	export default {
		props: {
			type: String
		},

		data() {
			return {
				...batchData(),
				workType:8
			}
		},

		mounted() {
			this.searchHandle();
		},

		methods: {
			...batchMethods(),

			/********搜索************/
			searchHandle(data){
				if (!data){
					data = {};
				}
				this.$refs.list.load({
					url: '/dic/defects/list',
					data,
					success: () => {
						this.batchData = [];
					}
				});
			},

			/******新建/编辑不良品项*******/
			editDicDefects(data) {
				this.globalDialog('defectsEdit', {data}, this.$refs.list.update);
			},

			/****批量删除不良品项****/
			batchRemoveDicDefects(){
				var ids = [];
				this.$refs.list.getData('selected').forEach(item => {
					ids.push(item.id);
				});
				
				this.$confirm({
					message:'确认删除' + ids.length + '条不良品项记录吗？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/dic/defects/remove/batch',
							data: {ids: ids},
							loading: true,
							success: data => {
								let Mtype = 'success';
								let message = '成功' + data.success_count + '条';
								if(data.fail_count > 0 && data.success_count > 0){
									Mtype = 'warn';
									message += '，失败'+data.fail_count+'条';
								}else if(data.fail_count > 0 && data.success_count == 0){
									Mtype = 'fail'
									message += '，失败'+data.fail_count+'条';
								}else{
									message = '成功删除' + data.success_count + '条记录';
								}
								this.$message({
									message: message,  // 提示内容,
									type: Mtype
								});
								//刷新
								this.$refs.list.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/******删除不良品项***********/
			removeDicDefects(data){
				this.$confirm({
					message:'确认删除不良品项【'+data.defects_name+'】？删除后不可恢复',  // 提示内容,
					// buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/dic/defects/remove',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								this.$refs.list.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/******加载系统业务日志列表**********/
			loadWorkLogDetail(){
				//打开模板选择弹窗
				this.globalDialog('workLogDetail',{
					props: {
						workType: this.workType
					}
				});
			},

			/******导入Excel数据**********/
			excelImport(){
				//打开模板选择弹窗
				this.globalDialog('excelImport',{
					props: {
						workType: this.workType
					}
				},this.importHandle);
			},

			/*********导入成功回调****************/
			importHandle(){
				setTimeout(() => {
					this.$refs.list.update();
				}, 300);
			},

			/******加载导入业务日志列表**********/
			loadImportLogDetail(){
				//打开模板选择弹窗
				this.globalDialog('importLogDetail',{
					props: {
						workType: this.workType
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>